import React, { Component } from 'react';
import { toast, ToastContainer, MDBCardImage, MDBTooltip, MDBBadge, MDBCardFooter, MDBPageNav, MDBPageItem, MDBPagination, MDBInput, MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Header from './ComponentFragments/Header';
import SelectSearch from 'react-select-search';

class VirtualStore extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            active: true,
            selectedPage: 1,
            shopData: [],
            filteredData: [],
            pageSize: 20,
            maxPages: 0,
            pages: [],
            dummy: 0,
            zoneData: [],
            selectedZone: ''
        });
        this.formatter = new Formatter();
        this.searchList = this.searchList.bind(this);
        this.getShopData = this.getShopData.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.setSelectedZone = this.setSelectedZone.bind(this);
    }

    componentWillMount() {
        this.getShopData();
        
    }


    async setSelectedZone(zone) {
        
        let dl = new DataLayer();
        let response = await dl.Get('/common/getvscartitemcount?zoneId=' + zone);
        let vsDataResponse = await dl.Get('/common/getvirtualstoredata?zoneId=' + zone);
        this.props.updateCartCount(response.data);
        this.props.setSelectedZoneId(zone);

        this.setState({
            selectedZone: zone,
            shopData: vsDataResponse.data,
            filteredData: vsDataResponse.data
        });
    }


    async getShopData() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let response = await dl.Get('/common/getzones');
        let zData = [];
        response.data.forEach((zone) => zData.push({ value: zone.shipZoneId, name: zone.zoneName }));

        let vsDataResponse = await dl.Get('/common/getvirtualstoredata?zoneId=' + zData[0].value);
        
        

        let countResponse = await dl.Get('/common/getvscartitemcount?zoneId=' + zData[0].value);
        this.props.updateCartCount(countResponse.data);

        this.setState({
            zoneData: zData,
            selectedZone: zData[0].value,
            shopData: vsDataResponse.data,
            filteredData: vsDataResponse.data
        });
        
        this.props.showHideCart(false);
        this.props.setSelectedZoneId(zData[0].value);
        this.props.loaderOff();
    }


    async addToCart(item) {
        if (document.getElementById(item.stockId).value == "" || document.getElementById(item.stockId).valueAsNumber < 1) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Please give a valid Qty.</span>, {
                closeButton: false
            });

        } else {
            
            item.qty = document.getElementById(item.stockId).valueAsNumber;
            item.zoneId = this.state.selectedZone;
            let available = item.availableToOrder
            if (item.qty > available) {
            //if (item.qty > item.available) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Cannot add more than is available to cart.</span>, {
                    closeButton: false
                });
                //this.props.loaderOff();
            } else {
                this.props.loaderOn();
                var dl = new DataLayer();
                let response = await dl.Post('/common/addtovscart', item);
                if (response.errorOccurred) {
                    toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Error Occurred.</span>, {
                        closeButton: false
                    });
                } else {
                    toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; {document.getElementById(item.stockId).valueAsNumber == 1 ? "Item added successfully." : "Items added successfully."} </span>, {
                        closeButton: false
                    });
                    item.available = item.available - item.qty;
                    item.availableToOrder = item.availableToOrder - item.qty;
                    this.props.updateCartCount(response.data);
                }
            }
            //this.props.loaderOff();
        }
        this.props.loaderOff();
    }







    searchList(phrase) {
        let arr = this.state.shopData.filter((item) => item.processingCode.toUpperCase().includes(phrase.toUpperCase()) || (item.invoiceDescription.toUpperCase().includes(phrase.toUpperCase())))
        this.setState({
            filteredData: arr
        });
    }

    render() {
        return (
            <div id="top">
                <Header headerText="Shop"
                    placeholderText="Search"
                    searchList={this.searchList}
                />
                <MDBRow className="mt-3">
                    <MDBCol sm="12">
                        <SelectSearch
                            options={this.state.zoneData}
                            placeholder="Zone..."
                            value={this.state.selectedZone}
                            search={false}
                            onChange={(selectedItem) => this.setSelectedZone(selectedItem.value)}
                        />
                    </MDBCol>
                </MDBRow>

                <MDBRow>
                    {
                        this.state.filteredData.map((item) => {

                            return (
                                <MDBCol xl="3" lg="4" md="6" sm="12" className="mb-r" >
                                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                        <MDBCardTitle>
                                            <h5>
                                                {item.hot ? (<span><MDBIcon icon="fire-alt" className="red-text" /> Hot Item</span>) : (<div></div>)}
                                            </h5>
                                        </MDBCardTitle>
                                        <MDBCardImage className="img-fluid" src={item.imgAvailable ? `https://tupp.tuppafrica.co.za/Images/virtualstore/` + item.stockId + `.jpg` : `https://tupp.tuppafrica.co.za/images/virtualstore/noimage.png`} />
                                        <br />
                                        <MDBCardText>
                                            <span style={{ fontSize: "16" }}><strong>{item.processingCode}  </strong></span><br />
                                            <span style={{ fontSize: "10" }}>{item.invoiceDescription}</span><br/><br/>
                                            {item.extendedDescription.trim() == '' ? <div></div> : <div><span style={{ fontSize: "10" }}>{item.extendedDescription}</span><br /><br /></div>}
                                            <span style={{ fontSize: "16" }}>Unit Price:&nbsp;<strong>{this.formatter.formatCurrency(item.price / 100)}</strong></span><br />
                                            <span style={{ fontSize: "16" }}>Pack Size:&nbsp;<strong>{item.packSize}</strong></span><br />
                                            {item.qtyAssigned != -1 ?
                                                <div>
                                                    <span style={{ fontSize: "16" }}>Assigned Cartons:&nbsp;<span style={{ color: "red" }}>{item.qtyAssigned}</span></span><br />Available To Order: {item.availableToOrder}
                                                    &nbsp;&nbsp;<MDBBtn tag="a" size="sm" floating className="pink lighten-2">
                                                        <MDBIcon icon="question-circle" />
                                                    </MDBBtn>
                                                </div> :
                                                <div><span style={{ fontSize: "16" }}>Only&nbsp;<span style={{ color: "red" }}>{item.available}</span>&nbsp;cartons available</span><br /></div>}
                                        </MDBCardText>
                                        <hr className="hr_grey" />
                                        <div className="flex-row text-center" >

                                            <MDBRow>
                                                <MDBCol>
                                                    <MDBInput id={item.stockId} min={0} type="number" label="Qty" required />
                                                </MDBCol>
                                                <MDBCol className="text-center">
                                                    <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToCart(item)}>
                                                        <MDBIcon icon="cart-plus" />
                                                    </MDBBtn>

                                                </MDBCol>
                                            </MDBRow>



                                        </div>
                                    </MDBCard>
                                </MDBCol>
                            )

                        })
                    }
                </MDBRow>

                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>

        )
    }
}

export default VirtualStore;


